module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-003.69dae903.jpg";